// Base URL of the backend API, from env or localhost default
export const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:3000/';
